import { HttpEventType } from '@angular/common/http';
import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import moment from 'moment';
import readXlsxFile from 'read-excel-file';
import { firstValueFrom } from 'rxjs';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { InventoryBalancesImportModel } from 'src/app/models/imports/inventory-balances-import.model';
import { LoadPreInvoicingModel } from 'src/app/models/invoicing/load-preinvoicing.models';
import { PreInvoicingAlertModel } from 'src/app/models/invoicing/pre-invoicing-alert.models';
import { WindowService } from 'src/app/services/authentication/window.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { InventoryService } from 'src/app/services/inventory/inventory.service';
import { BranchService } from 'src/app/services/management/branch.service';
import { CompanyService } from 'src/app/services/management/company.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { ReverseInventoryBalancesComponent } from '../reverse-inventory-balances/reverse-inventory-balances.component';

@Component({
  selector: 'app-inventory-balances-import',
  templateUrl: './inventory-balances-import.component.html',
  styleUrls: ['./inventory-balances-import.component.scss'],
  standalone: false
})
export class InventoryBalancesImportComponent implements OnInit {

  @ViewChild('reverseInventoryBalanceModal') reverseInventoryBalanceModalComponent?: CustomModalComponent | null = null;
  componentRegisterReverseInventoryBalance = ReverseInventoryBalancesComponent;

  private readonly branchService = inject(BranchService);
  private readonly companyService = inject(CompanyService);
  private readonly formBuilder = inject(FormBuilder);
  private readonly headerService = inject(HeaderService);
  private readonly inventoryService = inject(InventoryService);
  private readonly router = inject(Router);
  private readonly title = inject(Title);
  private readonly toastHandlerService = inject(ToastHandlerService);
  private readonly windowService = inject(WindowService);

  branchCode: number = 0;
  branchId: number = 0;
  companyCode: number = 0;
  companyId: number = 0;
  errorInventoryBalance: number = 0;
  eventFile: any;
  formImport: FormGroup = new FormGroup({});
  inventoryBalancesAlerts: PreInvoicingAlertModel[] = [];
  isOpened: string | undefined = undefined;
  listBranches: any[] = [];
  listCompanies: any[] = [];
  loadPreInvoicingModel: LoadPreInvoicingModel = new LoadPreInvoicingModel();
  nameFile: string = 'Ningún archivo seleccionado.';
  nameWindow: string = 'Importación Saldos Inventario';
  permissionUpdatable: boolean = false;
  projectName = ProjectName.projectName;
  url: string = "inventory-balances-import";
  visibleTxt: boolean = false;

  async ngOnInit() {
    this.validateForm();
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    this.headerService.setTitle(this.nameWindow);
    await this.getPermission();
  }

  attach() {
    document.getElementById('fileImport')?.click();
  }

  clearInputFile() {
    this.nameFile = 'Ningún archivo seleccionado.';
    if (this.eventFile) {
      this.eventFile.target.value = '';
    }
  }

  downloadErrorsTxt() {
    if (!this.inventoryBalancesAlerts || this.inventoryBalancesAlerts.length === 0) {
      this.toastHandlerService.showToast('error', 'No hay alertas para exportar.');
      return;
    }

    this.inventoryService.exportImportErrors(this.inventoryBalancesAlerts).subscribe({
      next: (blob: Blob) => {
        const file = new Blob([blob], { type: 'text/plain' });
        const url = window.URL.createObjectURL(file);
        const today = new Date();
        const formatDate = today.toISOString().split('T')[0];

        const a = document.createElement('a');
        a.href = url;
        a.download = `ErroresImportacionSaldosDeInventario_${formatDate}.txt`;
        a.click();

        window.URL.revokeObjectURL(url);
      },
      error: () => {
        this.toastHandlerService.showToast('error', 'Error al exportar el archivo');
      }
    });
  }

  downloadGuideImport() {
    this.inventoryService.downloadGuideImport().subscribe(data => {
      switch (data.type) {
        case HttpEventType.Response: {
          const downloadedFile = new Blob([data.body!], { type: data.body!.type });
          const a = document.createElement('a');
          a.setAttribute('style', 'display:none;');
          document.body.appendChild(a);
          a.download = "GuiaSaldosInventario.docx";
          a.href = URL.createObjectURL(downloadedFile);
          a.target = '_blank';
          a.click();
          document.body.removeChild(a);
          break;
        }
      }
    });
  }

  importInventoryBalances() {
    this.inventoryBalancesAlerts = [];
    this.errorInventoryBalance = 0;
    this.visibleTxt = false;

    if (!this.formImport.valid) {
      this.showValidationMessages();
      return;
    }
    let isOk: boolean = true;
    const input = document.getElementById("fileImport") as any;
    const rowsImports = new Array<InventoryBalancesImportModel>();
    let row: InventoryBalancesImportModel;
    let counter: number = 1, consecutive: number, date: Date, providerDocument: string, storeCode: number, articleCode: number,
      quantity: number, cost: number;
    if (input.files[0]) {
      readXlsxFile(input.files[0]).then(async (rows) => {
        if (rows.length <= 1) {
          this.toastHandlerService.showToast('warning', `El archivo ingresado no tiene registros para importar`);
          return;
        }
        rows.splice(0, 1);
        rows.forEach(element => {
          counter = counter + 1;
          let rowHasError = false;
          //A. Código Compañía:
          const companyCode = parseFloat(element[0] as string);
          if (isNaN(companyCode)) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna A. El código de la compañía no es válido.`;
            this.inventoryBalancesAlerts.push(alert);
            rowHasError = true;
          }
          if (companyCode != this.companyCode) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna A. La compañía del archivo no es igual a la compañía seleccionada.`;
            this.inventoryBalancesAlerts.push(alert);
            rowHasError = true;
          }

          //B. Código Sucursal:
          const branchCode = parseFloat(element[1] as string);
          if (isNaN(branchCode)) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna B. El código de la sucursal no es válido.`;
            this.inventoryBalancesAlerts.push(alert);
            rowHasError = true;
          }
          if (branchCode != this.branchCode) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna B. La sucursal del archivo no es igual a la sucursal seleccionada.`;
            this.inventoryBalancesAlerts.push(alert);
            rowHasError = true;
          }

          //C. Consecutivo:
          consecutive = parseFloat(element[2] as string);
          if (isNaN(consecutive)) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna C. El consecutivo no es válido.`;
            this.inventoryBalancesAlerts.push(alert);
            rowHasError = true;
          }

          //D. Documento Proveedor:
          providerDocument = element[3] as string;
          if (providerDocument == "" || providerDocument == null || providerDocument == undefined) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna D. El documento del proveedor no es válido.`;
            this.inventoryBalancesAlerts.push(alert);
            rowHasError = true;
          } else {
            if (providerDocument.length > 15) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna D. El documento del proveedor supera el tamaño máximo de caracteres (15).`;
              this.inventoryBalancesAlerts.push(alert);
              rowHasError = true;
            }
          }

          //E. Fecha:
          const dateEntryString = element[4] as string;
          if (dateEntryString == null || dateEntryString == "") {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna E. El campo de fecha de la Orden de Mantenimiento es obligatorio.`;
            this.inventoryBalancesAlerts.push(alert);
            rowHasError = true;
          }
          //Convierte fecha de string a Date
          date = moment(dateEntryString, 'DD/MM/YYYY HH:mm').toDate();
          if (!moment(dateEntryString, 'DD/MM/YYYY HH:mm').isValid()) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna E. El campo de fecha no es válido.`;
            this.inventoryBalancesAlerts.push(alert);
            rowHasError = true;
          }

          //F. Código Artículo:
          articleCode = parseFloat(element[5] as string);
          if (isNaN(articleCode)) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna F. El código del artículo no es válido.`;
            this.inventoryBalancesAlerts.push(alert);
            rowHasError = true;
          }

          //G. Código Bodega:
          storeCode = parseFloat(element[6] as string);
          if (isNaN(storeCode)) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna G. El código de la bodega no es válido.`;
            this.inventoryBalancesAlerts.push(alert);
            rowHasError = true;
          }

          //H. Cantidad:
          quantity = parseFloat(element[7] as string);
          if (isNaN(quantity)) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna H. La cantidad no es válido.`;
            this.inventoryBalancesAlerts.push(alert);
            rowHasError = true;
          } else {
            if (quantity <= 0) {
              const alert = new PreInvoicingAlertModel();
              alert.alertType = 1;
              alert.message = `Fila ${counter}, Columna H. La cantidad debe ser mayor a cero.`;
              this.inventoryBalancesAlerts.push(alert);
              rowHasError = true;
            }
          }

          //I. Costo:
          cost = parseFloat(element[8] as string);
          if (isNaN(cost)) {
            const alert = new PreInvoicingAlertModel();
            alert.alertType = 1;
            alert.message = `Fila ${counter}, Columna I. El costo no es válido.`;
            this.inventoryBalancesAlerts.push(alert);
            rowHasError = true;
          }
          if (!rowHasError) {
            row = new InventoryBalancesImportModel(
              counter, this.companyId, this.branchId, consecutive, date, providerDocument, storeCode, articleCode, quantity, cost
            );
            rowsImports.push(row);
          } else {
            isOk = false;
          }
        });
        if (isOk && rowsImports.length > 0) {
          try {
            const response = await firstValueFrom(this.inventoryService.importInventoryBalances(rowsImports));
            this.loadPreInvoicingModel = response;
            this.inventoryBalancesAlerts = response?.alerts ?? [];
            this.errorInventoryBalance = response?.preInvoicingStateId;

            if (this.errorInventoryBalance === 1) {
              this.visibleTxt = true;
              this.toastHandlerService.showToast(
                'error',
                'La importación terminó con errores, puede exportarlos si lo desea.',
                'ERROR');
            } else if (this.inventoryBalancesAlerts.length > 0) {
              this.visibleTxt = true;
              this.toastHandlerService.showToast('error', 'La importación terminó con alertas, puede exportarlas si lo desea');
            } else {
              this.visibleTxt = false;
              this.toastHandlerService.showToast('success', `La importación terminó exitosamente.`);
            }
            this.clearInputFile();
          } catch (error) {
            this.nameFile = 'Ningún archivo seleccionado.';
            console.error('Error al importar las Saldos de Inventario.', error);
          }
          (<HTMLInputElement>document.getElementById('fileImport')).value = '';
        } else {
          this.errorInventoryBalance = 1;
          this.visibleTxt = true;
          this.toastHandlerService.showToast(
            'error',
            'La importación terminó con errores, puede exportarlos si lo desea'
          );
        }
      });
    } else {
      this.toastHandlerService.showToast('error', 'No ha seleccionado ningún archivo.');
    }
  }

  async getAllLists(...listsToLoad: Array<'companies' | 'branches'>) {
    try {
      const lists = {
        companies: async () => {
          this.listCompanies = await firstValueFrom(this.companyService.getAllCompaniesForSelectAsync());
        },
        branches: async () => {
          this.listBranches = await firstValueFrom(this.branchService.GetAllBranchesByCompanyIdForSelectAsync(this.companyId));
        }
      };
      if (listsToLoad.length) {
        await Promise.all(listsToLoad.map(list => lists[list]()));
      } else {
        await Promise.all([
          lists.branches(),
          lists.companies()
        ]);
      }
    } catch (error) {
      console.error('Error obtener las listas.', error);
    }
  }

  async getBranch(branchId: number | null) {
    if (!branchId) {
      this.branchId = 0;
      this.branchCode = 0;
      return;
    }

    const branch = this.listBranches.find(x => x.value == branchId);
    this.branchId = branchId;
    this.branchCode = branch.code;
  }

  async getCompany(companyId: number | null) {
    if (!companyId) {
      this.companyId = 0;
      this.companyCode = 0;
      this.listBranches = [];
      this.validateForm();
      return;
    }

    const company = this.listCompanies.find(x => x.value == companyId);
    this.companyId = companyId;
    this.companyCode = company.code;
    await this.getAllLists('branches');
  }

  getNameFile(file: any) {
    this.eventFile = file;
    const files = this.eventFile.target.files;
    if (files.length != 0) {
      for (let i = 0; i < files.length; i++) {
        this.nameFile = files[i].name;
      }
    } else {
      this.nameFile = 'Ningún archivo seleccionado.';
    }
  }

  async getPermission() {
    let url = this.router.url as string
    url = url.substring(1);
    this.url = url;
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast(
          'error',
          `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`
        );
      }
    } else {
      localStorage.clear();
    }
    await Promise.all([
      this.getAllLists('companies'),
      this.getPermissionProfileByUrl(),
    ])
  }

  async getPermissionProfileByUrl() {
    try {
      const response = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
      this.permissionUpdatable = response;
    } catch (error) {
      console.error('Error al buscar los permisos.', error);
    }
  }

  reverseInventoryBalance() {
    this.reverseInventoryBalanceModalComponent && this.reverseInventoryBalanceModalComponent.show();
  }

  showValidationMessages() {
    const controlMessages: Record<string, Record<string, string>> = {
      companyId: {
        required: 'La compañía es obligatoria.',
        min: 'La compañía es obligatoria.',
      },
      branchId: {
        required: 'La sucursal es obligatoria.',
        min: 'La sucursal es obligatoria.'
      },
    };

    Object.keys(controlMessages).forEach(controlName => {
      const control = this.formImport.get(controlName);
      if (control && control.invalid && control.errors) {
        const errors = control.errors;
        Object.keys(errors).forEach(errorKey => {
          const message = controlMessages[controlName][errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message, 'Atención');
          }
        });
      }
    });
  }

  validateForm() {
    this.formImport = this.formBuilder.group({
      companyId: [0, [Validators.required, Validators.min(1)]],
      branchId: [0, [Validators.required, Validators.min(1)]],
    });
  }
}
